import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventInvoicesMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  event_account_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type CreateEventInvoicesMutation = { __typename?: 'Mutation', createEventInvoices: boolean };


export const CreateEventInvoicesDocument = gql`
    mutation CreateEventInvoices($event_id: ID!, $event_account_ids: [ID!]!) {
  createEventInvoices(event_id: $event_id, event_account_ids: $event_account_ids)
}
    `;
export type CreateEventInvoicesMutationFn = Apollo.MutationFunction<CreateEventInvoicesMutation, CreateEventInvoicesMutationVariables>;

/**
 * __useCreateEventInvoicesMutation__
 *
 * To run a mutation, you first call `useCreateEventInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventInvoicesMutation, { data, loading, error }] = useCreateEventInvoicesMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_account_ids: // value for 'event_account_ids'
 *   },
 * });
 */
export function useCreateEventInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventInvoicesMutation, CreateEventInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventInvoicesMutation, CreateEventInvoicesMutationVariables>(CreateEventInvoicesDocument, options);
      }
export type CreateEventInvoicesMutationHookResult = ReturnType<typeof useCreateEventInvoicesMutation>;
export type CreateEventInvoicesMutationResult = Apollo.MutationResult<CreateEventInvoicesMutation>;
export type CreateEventInvoicesMutationOptions = Apollo.BaseMutationOptions<CreateEventInvoicesMutation, CreateEventInvoicesMutationVariables>;